angular.module('aprima-provider-api').factory('PatientRecallsRepository',
    ['AprimaRestangular', 'AprimaAnalytics',
        function (AprimaRestangular, AprimaAnalytics) {
            'use strict';

            return {
                getRecalls: getRecalls
            };

            function getRecalls(id) {
                var timing = AprimaAnalytics.startTiming('PatientRecallsRepository', 'api', 'get recalls');
                return AprimaRestangular.get().one('patients', id).getList('recalls').finally(timing.stop);
            }
        }
    ]
);